import { render, staticRenderFns } from "./ClienteleManagement.vue?vue&type=template&id=acc9422e&scoped=true&"
import script from "./ClienteleManagement.vue?vue&type=script&lang=js&"
export * from "./ClienteleManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClienteleManagement.vue?vue&type=style&index=0&id=acc9422e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc9422e",
  null
  
)

export default component.exports